import { Box, VStack } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'
import type { FC, RefObject } from 'react'

import { AnswerItem } from './AnswerItem'
import type { ChatResponse } from './useAskCopilot'

type Props = {
  chat: ChatResponse
  customer: string
  showThumbs?: boolean
  containerRef?: RefObject<HTMLElement | null>
}

const opacity = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const AskCopilotChat: FC<Props> = ({
  chat,
  customer,
  showThumbs = false,
  containerRef,
}) => {
  return (
    <Box
      width="clamp(240px, 800px, 100%)"
      mx="auto"
      animation={`${opacity} 140ms ease-in`}
    >
      <VStack spacing="0" align="stretch">
        {chat.answers.map((answer, answerIdx) => (
          <AnswerItem
            key={answer.queryId}
            answer={answer}
            answerIdx={answerIdx}
            customer={customer}
            showThumbs={showThumbs}
            containerRef={containerRef}
          />
        ))}
      </VStack>
    </Box>
  )
}
